import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import TablePaginationCustom from 'src/components/Table/TablePaginationCustom';
import Table from 'src/components/Table';
import PartialReportDetailRow from './PartialReportDetailRow';

if (!process.env.REACT_APP_TABLE_SIZE) {
  console.error(
    'REACT_APP_TABLE_SIZE variable not loaded properly. Check your .env file please!'
  );
}

const Tbody = ({ bureauReportDetailList }) =>
  bureauReportDetailList.map(bureauReportDetail => (
    <PartialReportDetailRow
      key={bureauReportDetail.id}
      {...bureauReportDetail}
    />
  ));

const PartialReportDetailTable = ({
  className,
  bureauReportDetailList,
  count,
  page,
  handleChangePage,
  loading,
  ...rest
}) => {
  const { t } = useTranslation();

  const theads = useMemo(
    () => () => (
      <TableRow>
        <TableCell variant="head" key="folio" align="center">
          {t('BUREAU_REPORTS.FOLIO')}
        </TableCell>
        <TableCell variant="head" key="client" align="left">
          {t('COMMON.CLIENT')}
        </TableCell>
        <TableCell variant="head" key="currentBalance" align="center">
          {t('BUREAU_REPORTS.CURRENT_BALANCE')}
        </TableCell>
        <TableCell variant="head" key="overdueBalance" align="center">
          {t('BUREAU_REPORTS.OVERDUE_BALANCE')}
        </TableCell>
        <TableCell variant="head" key="lastPaymentAmount" align="center">
          {t('BUREAU_REPORTS.LAST_PAYMENT_AMOUNT')}
        </TableCell>
        <TableCell variant="head" key="lastPaymentDate" align="center">
          {t('BUREAU_REPORTS.LAST_PAYMENT_DATE')}
        </TableCell>
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(
    () => () => <Tbody bureauReportDetailList={bureauReportDetailList} />,
    [bureauReportDetailList]
  );

  const pagination = useMemo(
    () => () => (
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={count}
        rowsPerPage={+process.env.REACT_APP_TABLE_SIZE}
        page={page}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationCustom}
        labelDisplayedRows={({ from, to, count: c }) => {
          return `${from}-${to} ${t('COMMON.OF')} ${c}`;
        }}
      />
    ),
    [page, bureauReportDetailList, count, handleChangePage, t]
  );

  return (
    <Table
      {...rest}
      variant="outlined"
      tbody={tbody}
      theads={theads}
      pagination={pagination}
      loading={loading}
    />
  );
};

PartialReportDetailTable.propTypes = {
  className: PropTypes.string,
  bureauReportDetailList: PropTypes.array.isRequired,
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default PartialReportDetailTable;
